<template>
  <div class="border-b border-n-700 only:border-none" :class="{ 'bg-n-600': sectionSelected }">
    <div
      v-if="showSectionName"
      class="flex items-center justify-between p-4 text-sm text-n-200 font-body cursor-pointer"
      @click="$emit('selectedSection')"
    >
      <div class="flex items-center">
        <l-radio
          :model-value="sectionSelected"
          :value="true"
          :name="sectionName"
          @update:model-value="$emit('selectedSection')"
        />
        {{ sectionName }}
      </div>
      <l-icon
        v-if="showRemove"
        name="delete"
        class="justify-end text-n-0 cursor-pointer"
        @click.stop="$emit('onRemove')"
      />
    </div>
    <vue-draggable
      :model-value="elements"
      :empty-insert-threshold="40"
      direction="vertical"
      group="products"
      :force-fallback="true"
      :delay="250"
      :delay-on-touch-only="false"
      :touch-start-threshold="5"
      :animation="200"
      :component-data="{ name: 'list' }"
      @start="$emit('draggableStart')"
      @end="$emit('draggableEnd')"
      @update="event => $emit('onUpdate', event)"
      @add="event => $emit('onAdd', event)"
    >
      <div v-for="element in elements" :id="element.id" :key="element.id">
        <slot v-bind="{ item: element }"></slot>
      </div>
    </vue-draggable>
    <div ref="endSection"></div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { VueDraggable, type SortableEvent } from 'vue-draggable-plus'

import { LIcon, LRadio } from '@last/core-ui/paprika'

type Props = {
  showRemove?: boolean
  showSelectRadio?: boolean
  sectionName: string
  sectionSelected?: boolean
  elements: any[]
  showSectionName?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showRemove: false,
  showSelectRadio: true,
  sectionSelected: false,
  elements: () => [],
  showSectionName: true
})

defineEmits<{
  selectedSection: []
  onRemove: []
  onUpdate: [SortableEvent & { data?: any }]
  onAdd: [SortableEvent & { data?: any }]
  draggableStart: []
  draggableEnd: []
}>()

const endSection = ref<HTMLDivElement>()

const elementsLength = computed(() => {
  return props.elements.length
})

watch(elementsLength, () => {
  const scrollTarget = endSection.value
  if (scrollTarget) {
    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
})
</script>
